import type {
  InterstateOnChangeEvent,
  SearchInputChangeEventValue,
  SearchOption
} from "@dealer-center/core-components";
import { SearchInput } from "@dealer-center/core-components";
import { findMenuItemByLabel, getSearchOptions } from "./helper";
import { useNavBarStore } from "../../store";
import { useNavigate } from "react-router-dom";
import { handleNavMenuClick } from "../navigation/links-menu-new";

import { useState } from "react";

export interface OnSearchInterface {
  inputValue: string;
  trigger: "itemSelected" | "searchButtonClicked";
}

export const SearchBar = () => {
  const { onSearch, setSelectedAccountId } = useNavBarStore();
  const navigate = useNavigate();
  const { linksMenu, availableAccounts } = useNavBarStore();
  const [searchOptions, setSearchOptions] = useState<SearchOption[]>(
    getSearchOptions([], availableAccounts)
  );
  const onSearchInternal = (value: OnSearchInterface) => {
    if (value.trigger === "itemSelected") {
      const foundAccount = availableAccounts?.find(
        account => account.label === value.inputValue
      );
      if (foundAccount && foundAccount.value && setSelectedAccountId) {
        setSelectedAccountId(foundAccount.value.toString());
        return;
      }
      if (linksMenu) {
        const foundLinksMenuItem = findMenuItemByLabel(
          linksMenu,
          value.inputValue
        );
        if (foundLinksMenuItem) {
          const { url, action } = handleNavMenuClick(foundLinksMenuItem);
          switch (action) {
            case "open":
              window.open(url, "_blank");
              break;
            case "navigate":
              navigate(url);
              break;
            case "redirect":
              window.location.href = url;
              break;
            case "none":
              break;
          }
        }
      }
    }
    if (onSearch) {
      onSearch(value);
    }
  };
  const searchButtonClicked = (
    value: InterstateOnChangeEvent<SearchInputChangeEventValue>
  ) => {
    onSearchInternal({
      inputValue: value.target.value || "",
      trigger: "searchButtonClicked"
    });
  };
  const searchItemSelected = (value: InterstateOnChangeEvent<SearchOption>) => {
    if (!value.target.value) return;
    onSearchInternal({
      inputValue: value.target.value.label || "",
      trigger: "itemSelected"
    });
  };
  return (
    <SearchInput
      groupOptions={true}
      options={searchOptions}
      placeholder="Search"
      sx={{
        width: "30ch",
        margin: "0 16px"
      }}
      onChange={searchItemSelected}
      onInputChange={(
        event: InterstateOnChangeEvent<SearchInputChangeEventValue>
      ) => {
        const value = event.target.value;
        if (value && value.length > 2) {
          setSearchOptions(getSearchOptions(linksMenu, availableAccounts));
        } else {
          setSearchOptions(getSearchOptions([], availableAccounts));
        }
      }}
      onSearchClick={searchButtonClicked}
    />
  );
};
